module.exports = __webpack_public_path__ + "static/media/ils-file.6327c769.svg";